import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TypeCheckbox from '../form/form-fields/TypeCheckbox';

export const StepInlineAttachments = ({
  dataCollection,
  updateDataCollection,
  updateValidation,
}) => {
  const { t } = useTranslation();

  const [usedPositionTypes, setUsedPositionTypes] = useState([]);

  const attachmentTypes = [
    {
      label: t('HOAI Calculation'),
      key: 'hoaiCalculation',
      positionKey: 'hoaiPhase',
    },
  ];

  function getPositionTypes(positions) {
    const types = [];
    positions.forEach((position) => {
      if (position.type && !types.includes(position.type)) {
        types.push(position.type);
      }
    });
    return types;
  }

  useEffect(() => {
    updateValidation(true);
    if (dataCollection?.positions) {
      setUsedPositionTypes(getPositionTypes(dataCollection?.positions));
    }
  }, [dataCollection?.positions]);

  function handleAttachmentChange(key) {
    const newInlineAttachments = dataCollection?.inlineAttachments || [];

    if (newInlineAttachments.includes(key)) {
      var index = newInlineAttachments.indexOf(key);
      if (index !== -1) {
        newInlineAttachments.splice(index, 1);
      }
    } else {
      newInlineAttachments.push(key);
    }
    updateDataCollection({ inlineAttachments: newInlineAttachments });
  }

  return (
    <Box className="flex flex-col gap-2">
      <Typography fontWeight={500} fontSize={16}>
        {t('Which attachments should be automatically generated and sent?')}
      </Typography>
      {attachmentTypes.map((type) => {
        if (usedPositionTypes.includes(type.positionKey)) {
          return (
            <TypeCheckbox
              field={type}
              dataCollection={{
                [type.key]: dataCollection?.inlineAttachments?.includes(
                  type.key
                ),
              }}
              updateValidationOnChange={() => handleAttachmentChange(type.key)}
            />
          );
        }
      })}
    </Box>
  );
};

export function hasInlineAttachments(positions) {
  if (!positions) return false;

  const attachmentTypes = ['hoaiPhase'];

  var hasAttachments = false;
  positions.forEach((position) => {
    const { type } = position;
    if (attachmentTypes.includes(type)) hasAttachments = true;
  });

  return hasAttachments;
}
